
import { Options, Vue } from 'vue-class-component';

import AccordionTitle from '@/components/AccordionTitle.vue';
import Button from '@/components/Button.vue';

import arrowSVG from '@/components/svg/SVGArrow.vue';

@Options({
  name: 'Leave List',
  props: [
    'title',
    'userLeaveList',
    'formatDate',
    'withdrawRequest',
    'deleteDeclined',
    'approveRequest',
    'declineRequest',
    'hrViewLeave',
    'userInfoData',
    'isHRAdminReadOnly',
  ],
  components: {
    AccordionTitle,
    Button,
    arrowSVG,
  },
  data() {
    return {
      listToggle: true,
    };
  },
  methods: {
    parseStatusTitle(status: string) {
      let parsed;
      switch (status) {
        case 'pending-approval':
          parsed = 'Pending Approval';
          break;
        case 'pending-withdrawal':
          parsed = 'Pending Withdrawal';
          break;
        default:
          parsed = status;
      }
      return parsed;
    },
    parseDurationType(type: string, hours: number) {
      let parsed;
      switch (type) {
        case 'full_day':
          parsed = `Full Day (${hours} Hours)`;
          break;
        case 'half_day':
          parsed = `Half Day (${hours} Hours)`;
          break;
        case 'custom':
          parsed = `Custom (${hours} Hours)`;
          break;
        default:
          parsed = 'Error';
      }
      return parsed;
    },
  },
})
export default class LeaveList extends Vue {}
